import {IRequestMeta, postRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";
import {SocialUserAccountType, UserRegistrationSource} from "@pg-rp/common-types";

const thirdPartyLoginApiLink = apiLink.user.thirdPartyLogin({});

interface ISocialAuthResponse {
    type: number;
    login_method: number;
    redirect_to: string | null;
    login_token: string | null;
    is_new: boolean;
    user_id: number;
}

const socialAuth =
    (
        accountType: SocialUserAccountType,
        options?: {
            login_method?: number;
            source?: UserRegistrationSource;
            client_id?: string;
        }
    ) =>
    (token: string) => {
        const credentials = accountType === SocialUserAccountType.GOOGLE_ONE_TAP ? {credential: token} : {access_token: token};

        const additionalParams = {
            ...(options?.source && {source: options.source}),
            ...(options?.client_id && {client_id: options.client_id})
        };

        return postRequest<IRequestMeta, ISocialAuthResponse>({}, thirdPartyLoginApiLink(null), {
            type: accountType,
            login_method: options?.login_method || 1,
            ...credentials,
            ...additionalParams
        });
    };

export const googleAuth = socialAuth(SocialUserAccountType.GOOGLE);
export const facebookAuth = socialAuth(SocialUserAccountType.FACEBOOK);

export const googleOneTapAuth = (source: UserRegistrationSource, client_id: string) =>
    socialAuth(SocialUserAccountType.GOOGLE_ONE_TAP, {
        source,
        client_id
    });
